import { atom } from 'recoil';
import axios from '../utils/axios';
// eslint-disable-next-line import/extensions
import localStorageEffect from './localStorageEffect.js';
import { ProductType } from '../@types/model/productType';

const productTypeState = atom<ProductType[]>({
  key: 'productType',
  default: [],
  effects: [localStorageEffect('productType')]
});

const getProductTypes = async () => {
  let productTypes: ProductType[] = (await axios.get('/api/v2/product-type')).data.data
    .filter((dat: any) => {
      if (dat?.attributes?.status === 'deleted') return false;
      return true;
    })
    .map((dat: any) => {
      return dat.attributes as ProductType;
    })
    .map((pt: ProductType) => {
      if (pt.grn) {
        if (pt.grn.split(':').length === 3) {
          return {
            ...pt,
            guid: pt.grn.split(':')[2]
          };
        }
      }
      return pt;
    })
    .sort((a: ProductType, b: ProductType) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  return productTypes;
};

export { productTypeState, getProductTypes };
